import { Form } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PhysicalCustomerForm from '../../../forms/PhysicalCustomerForm';
import { getLoginFormOptions } from '../../../../../services/login/Login.api';
import { registerPhysicalCustomer } from '../../../../../services/customer/authServices';
import formSetDynamicErrors from '../../../../../utils/functions/formSetDynamicErrors';

function AddPhysicalCustomer() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [options, setOptions] = useState({});

  const fetchFormOptions = async () => {
    const res = await getLoginFormOptions();
    setOptions(res.data);
  };

  useEffect(() => {
    fetchFormOptions();
  }, []);

  const onFinish = async (values) => {
    try {
      const res = await registerPhysicalCustomer({
        ...values,
        repeat_password: values?.password,
        agree_to_service_conditions: true,
        verification: true,
        verified: 'email',
      });
      if (res.status === 'success') {
        navigate('/admin/customers');
      }
    } catch (e) {
      formSetDynamicErrors({ e, form });
    }
  };
  return (
    <PhysicalCustomerForm form={form} options={options} onFinish={onFinish} />
  );
}

export default AddPhysicalCustomer;
